<script setup lang="ts">
const controller = defineModel<boolean>('controller', { default: false });
const emit = defineEmits<{
  (e: 'close'): void;
}>();

const authStore = useAuthStore();
const siteStore = useSiteStore();

const currentPage = computed<string | string[] | undefined>(() => {
  if (!authStore.getAccountModalPage) return useAccountOptions()[0].id;
  return authStore.getAccountModalPage;
});

const component = computed(() => {
  return (
    useAccountOptions().find(({ id }) => id === currentPage.value)?.component ||
    useAccountOptions()[0].component
  );
});

const { $t } = useNuxtApp();
const modalTitle = computed(() => {
  const phone = authStore.currentUser?.primaryMobileNumber?.mobileNumber
    ? ` (${authStore.currentUser.primaryMobileNumber?.mobileNumber})`
    : '';
  return `${$t('account-options')}${phone}`;
});

const closeModal = () => {
  authStore.setAccountModalPage(null);
  emit('close');
};
</script>

<template>
  <DesignSystemModal
    v-model:controller="controller"
    :title="modalTitle"
    :show-close="true"
    size="100%"
    container-class="h-fit !container"
    title-container-class="hidden sm:block"
    z-index="z-40"
    type="account"
    @close="closeModal()"
  >
    <template #modal-content>
      <UserAccountLayout>
        <div v-if="!authStore.loggedIn" class="space-y-2">
          <div class="text-xl font-bold text-center">
            {{ $t('not-logged-in') }}
          </div>
          <div class="text-center">{{ $t('login-to-proceed') }}</div>
          <div class="flex justify-center">
            <DesignSystemButton @click="siteStore.activateModal('login')">
              {{ $t('login') }}
            </DesignSystemButton>
          </div>
        </div>
        <component :is="component" v-else :key="String(currentPage)" />
      </UserAccountLayout>
    </template>
  </DesignSystemModal>
</template>
